
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">AI数字人：重塑教育和在线学习的面貌</h2>
                    <div class="time">2024-06-05 11:00:10</div>
                    <div class="start">
                        人工智能（AI）数字人是一种基于人工智能技术而诞生的虚拟人物，具有逼真的外观和智能交互能力。在教育和在线学习领域，人工智能数字人逐渐发挥出更强的竞争力，为学生提供了更加个性化、互动性强的学习体验，重塑了教育和在线学习的面貌。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/326.png" alt="AI数字人：重塑教育和在线学习的面貌" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t">1.	个性化教学</div>
                        <div class="list-text">
                            AI数字人可以根据学生的学习特点和需求，提供个性化的教学内容和方式。通过分析学生的学习行为和反馈，AI数字人可以动态调整教学策略，帮助学生更好地理解和掌握知识。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t">2.	互动式学习</div>
                        <div class="list-text">
                            AI数字人可以与学生进行互动，回答问题、解释概念，并给出实时反馈和指导。这种互动式学习方式可以激发学生的学习兴趣，提高学习效果。



                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t">3.	多模态学习</div>
                        <div class="list-text">
                            AI数字人可以结合语言、视觉、听觉等多种方式，向学生传递知识。通过多模态学习，学生可以更全面地理解和吸收知识。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t">4.	辅助教学工具</div>
                        <div class="list-text">
                            AI数字人可以作为教学辅助工具，帮助教师管理课堂教学、制定教学计划，提供教学资源和素材。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            与传统的教学方式相比，AI数字人可以大大降低教育成本。通过在线学习平台，学生可以随时随地与AI数字人进行学习互动，不再受时间和地点的限制，节省了教育资源和成本。尽管AI数字人在教育和在线学习中具有巨大潜力，但也面临一些挑战，例如，如何确保AI数字人的教学质量和效果，如何解决学生对AI数字人的接受度和信任度等问题都是需要解决的难题。
                        </div>
                    </div>
                    <div class="end">
                        总的来说，人工智能在教育和在线学习中的应用前景十分广阔，随着技术的储蓄和完善，相信AI数字人将会在教育领域发挥越来越重要的作用，为学生提供了更加个性化、互动性强的学习体验，推动教育创新和进步。未来，随着人工智能技术的进一步成熟和完善，它代表教育和学习领域中不可或缺的内容，为教育带来更多的创新和变革。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "AI数字人：重塑教育和在线学习的面貌-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "AI数字人：重塑教育和在线学习的面貌,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "人工智能（AI）数字人是一种基于人工智能技术而诞生的虚拟人物，具有逼真的外观和智能交互能力",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo326.vue